import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

//Custom components
import { CustomTab, EmptyScreen, Loader } from '../../../Components/Others';
import { PortfolioHoldingsCard } from '../../../Components/Card';
import { APIService } from '../../../Service';


const TAB_DATA = [
    {
        id: 1,
        label: "Goals"
    },
    {
        id: 3,
        label: "Smart Basket"
    },
    {
        id: 5,
        label: "Insta Save"
    },
    {
        id: 4,
        label: "Gold Maxx"
    },
    {
        id: 2,
        label: "Self Managed"
    },
];


const InternalHoldings = ({ portfolioDetails, toggleXirr, overviewData, handleDetail, handleTab }) => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const location = useLocation();
    const { id } = useParams();

    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        if (state?.portfolio_inner_tab_index) {
            setTabIndex(state.portfolio_inner_tab_index);
        } else {
            setTabIndex(portfolioDetails.current_tab || 1);
        }
    }, [state]);

    useEffect(() => {
        if (tabIndex !== 0) {
            if (tabIndex === 1 || tabIndex === 3) {
                _getPortfolioSummary();
            } else {
                _getPortfolioSelfManaged();
            }
        }
    }, [tabIndex]);


    // handle tab change 
    const _handleTabChange = (tab_id) => {
        navigate(location.pathname.includes("support") ? `/support/${id}` : `/customers/${id}`, {
            state: {
                ...state,
                portfolio_tab_index: state.portfolio_tab_index,
                portfolio_inner_tab_index: tab_id
            }
        });
        handleTab(tab_id)
    };


    const [loader, setLoader] = useState(false);
    const [summaryData, setSummaryData] = useState({});

    // API - Get portfolio
    const _getPortfolioSummary = () => {
        let is_post = true;
        let url = 'user/summary';
        let request = {
            "type": tabIndex,
            "is_external": false,
            "customer_id": id
        };

        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setSummaryData(response.data);
                overviewData(response.data);
            } else {
                setSummaryData({});
            }
            setLoader(false);
        })
    };

    // API - Get portfolio self managed
    const _getPortfolioSelfManaged = () => {
        let is_post = true;
        let url = 'user/get-self-managed';
        let request = {
            "type": tabIndex,
            "is_external": false,
            "customer_id": id
        };

        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setSummaryData(response.data);
                overviewData(response);
            } else {
                setSummaryData([{ data: [] }]);
                // summaryData[0]?.data?.length
            }
            setLoader(false);
        })
    };

    return (
        <div>
            <div className='d-flex align-items-center gap-12px '>
                <CustomTab className="w-132px px-3 text-center"
                    type={2}
                    data={TAB_DATA}
                    selectedTab={tabIndex}
                    handleClick={_handleTabChange} />
            </div>

            {loader ?
                <Loader className="min-vh-50" />
                :
                <div className='pe-4 pt-4 min-vh-50'>
                    {/* Goals    */}
                    {tabIndex === 1 &&
                        <>
                            {summaryData?.allocation_data?.length !== 0 ?

                                <div className='row g-3 '>
                                    {summaryData?.allocation_data?.map((data, key) => (
                                        <div className="col-6" key={key}>
                                            <PortfolioHoldingsCard type={1}
                                                toggleXirr={toggleXirr}
                                                data={data}
                                                handleNavigation={() => { }}
                                                handleCardClick={() => handleDetail(tabIndex, data.id)} />
                                        </div>
                                    ))}
                                </div>
                                :
                                <EmptyScreen
                                    image={require('../../../Assets/Image/NotFound/no-data.png')}
                                    title='No data found'
                                    description={``}
                                />
                            }
                        </>
                    }

                    {/* Basket */}
                    {tabIndex === 3 &&
                        <>
                            {summaryData?.allocation_data?.length !== 0 ?
                                <div className='row g-3 '>
                                    {summaryData?.allocation_data?.map((data, key) => (
                                        <div className="col-6" key={key}>
                                            <PortfolioHoldingsCard type={2}
                                                toggleXirr={toggleXirr}
                                                data={data}
                                                handleNavigation={() => { }}
                                                handleCardClick={() => handleDetail(tabIndex, data.id)} />
                                        </div>
                                    ))}
                                </div>
                                :
                                <EmptyScreen
                                    image={require('../../../Assets/Image/NotFound/no-data.png')}
                                    title='No data found'
                                    description={``}
                                />
                            }
                        </>
                    }

                    {/* Insta Save */}
                    {tabIndex === 5 &&
                        <>
                            {summaryData.length !== 0 && summaryData[0]?.data?.length !== 0 ?
                                <div className='row g-3'>
                                    {summaryData[0]?.data.map((data, key) => (
                                        <div className="col-6" key={key}>
                                            <PortfolioHoldingsCard type={3}
                                                data={data}
                                                handleNavigation={() => { }}
                                                toggleXirr={toggleXirr}
                                                handleCardClick={() => handleDetail(tabIndex, data.investment_id)} />
                                        </div>
                                    ))}
                                </div>
                                :
                                <EmptyScreen
                                    image={require('../../../Assets/Image/NotFound/no-data.png')}
                                    title='No data found'
                                    description={``}
                                />
                            }
                        </>
                    }

                    {/* Gold maxx */}
                    {tabIndex === 4 &&
                        <>
                            {summaryData[0]?.data?.length !== 0 ?
                                <div className='row g-3'>
                                    {summaryData[0]?.data.map((data, key) => (
                                        <div className="col-6" key={key}>
                                            <PortfolioHoldingsCard type={3}
                                                data={data}
                                                handleNavigation={() => { }}
                                                toggleXirr={toggleXirr}
                                                handleCardClick={() => handleDetail(tabIndex, data.investment_id)} />
                                        </div>
                                    ))}
                                </div>
                                :
                                <EmptyScreen
                                    image={require('../../../Assets/Image/NotFound/no-data.png')}
                                    title='No data found'
                                    description={``}
                                />
                            }
                        </>
                    }

                    {/* Self managed */}
                    {tabIndex === 2 &&
                        <>
                            {summaryData[0]?.data?.length !== 0 ?
                                <div className='row g-3'>
                                    {summaryData[0]?.data.map((data, key) => (
                                        <div className="col-6" key={key}>
                                            <PortfolioHoldingsCard type={3}
                                                data={data}
                                                handleNavigation={() => { }}
                                                toggleXirr={toggleXirr}
                                                handleCardClick={() => handleDetail(tabIndex, data.investment_id)} />
                                        </div>
                                    ))}
                                </div>
                                :
                                <EmptyScreen
                                    image={require('../../../Assets/Image/NotFound/no-data.png')}
                                    title='No data found'
                                    description={``}
                                />
                            }
                        </>
                    }
                </div>
            }
        </div>
    )
}

export default InternalHoldings;
